import { HTMLAttributes, useMemo, useState } from 'react';
import { useWindowSize } from '@jove-frontend/uikit';
import { Close } from '@mui/icons-material';
import { Box, Drawer, IconButton } from '@mui/material';
import clsx from 'clsx';

type Anchor = 'top' | 'left' | 'bottom' | 'right';

type CustomDrawerProps = HTMLAttributes<HTMLDivElement> & {
  anchor?: Anchor;
  close?: () => void;
  showClose?: boolean; // whether show close button
  width?: string;
  closeBtnClassName?: string; // close button style
};

// custom a drawer
const CustomDrawer = (props: CustomDrawerProps) => {
  const { anchor, close, children, showClose = true, width, className, closeBtnClassName } = props;
  const [open, setOpen] = useState(true);
  const windowSize = useWindowSize();

  /**
   * methods
   */
  const closeDrawerAction = () => {
    setOpen(false);
    if (close) close();
  };

  return (
    <Drawer anchor={anchor || 'right'} open={open} onClose={closeDrawerAction}>
      <Box style={width ? { width } : { maxWidth: `${windowSize.width * 0.8}px`, minWidth: `${windowSize.width * 0.2}px` }} className={clsx('flex h-full flex-col overflow-hidden', className)}>
        {showClose && (
          <Box className="flex h-10 flex-row items-center justify-end px-2 pt-2">
            <IconButton className={clsx('h-8 w-8 text-[#999]', closeBtnClassName)} aria-label="close" onClick={closeDrawerAction}>
              <Close />
            </IconButton>
          </Box>
        )}
        {children}
      </Box>
    </Drawer>
  );
};

export default CustomDrawer;
